import React from 'react'
import {Modal} from '@thryvlabs/maverick'

export const RETAIN_WEBSITE_MODAL_STATES = {
  CLOSE: 'close',
  OPEN: 'open',
  ANSWERED_YES: 'answered_yes',
  ANSWERED_NO: 'answered_no',
}

export function RetainWebsiteModal({state, setState}) {
  return (
    <Modal
      openOnLoad={state === RETAIN_WEBSITE_MODAL_STATES.OPEN}
      variant="default"
      title="Does the client want to retain their Thryv website?"
      hideX
      disableBackdropClick
      width="500px"
      data-testid="retain-website-modal"
      footer
      action
      footerPrimary="No"
      btnActionText="Yes"
      actionClose
      primaryClose
      primaryAction={() => setState(RETAIN_WEBSITE_MODAL_STATES.ANSWERED_NO)}
      btnAction={() => setState(RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES)}
    />
  )
}
